<template>
  <div>
    <div class="calendar-grid">
      <div class="day-name" v-for="(day, i) in dayNames" :key="i">
        {{ day }}
      </div>

      <CalendarDay
        v-for="(date, i) in calendarDays"
        :key="i"
        :date="date"
        :facturas="facturas"
        :isCurrentMonth="moment(date).month() === month"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CalendarDay from './CalendarDay.vue'

export default {
  components: { CalendarDay },
  props: {
    year: Number,
    month: Number,
    facturas: Array
  },
  computed: {
    dayNames() {
      return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
    },
    calendarDays() {
      const start = moment({ year: this.year, month: this.month }).startOf('month')
      const end = moment(start).endOf('month')

      const firstDayOfGrid = moment(start).startOf('week')
      const lastDayOfGrid = moment(end).endOf('week')

      const days = []
      const day = moment(firstDayOfGrid)

      while (day.isBefore(lastDayOfGrid, 'day') || day.isSame(lastDayOfGrid, 'day')) {
        days.push(day.format('YYYY-MM-DD'))
        day.add(1, 'day')
      }

      return days
    }
  },
  methods: {
    moment 
  }
}
</script>

<style scoped>
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}
.day-name {
  font-weight: 600;
  font-size: 13px;
  text-align: center;
  padding: 8px 0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}
</style>
